module.exports = {
  ...require('./lib/market-qrcode'),
  ...require('./lib/qrcode'),
  ...require('./lib/square-qrcode'),
};
